'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';
import raven from 'raven';

class EmployeeController extends FormController {
    /* @ngInject */
    constructor(EmployeesService,
                $scope, $window, $mdDialog, $mdMenu) {
        let employee = $scope.$parent.$resolve.employee;
        super(employee, 'Gestor', EmployeesService);

        Object.assign(this, {
            EmployeesService,
            $scope, $window, $mdDialog, $mdMenu
        });
        this.btnEnabled = true;
    }

    invite($event) {
        this.showInviteSpin = true;
        let msg = `La invitacion a ${this.model.email} esta siendo enviada.`;
        this.EmployeesService.invite(this.model).then(() => {
            this.showInviteSpin = false; 
            return this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Invitacion en proceso de envio')
                    .textContent(msg)
                    .ok('Aceptar')
                    .targetEvent($event)
            );
        }).catch(err => {
            raven.captureException(err);
        });
    }
}

export default EmployeeController;
